import { defineNuxtPlugin } from 'nuxt/app'
import feature from './feature'
import announcement from './announcement'
import autoPopup from './autoPopup'
import type { Plugin } from '~/plugins/plugins'

export const engagementPlugin: Plugin = (nuxtApp) => {
  nuxtApp.provide('engagement', {
    feature: feature(),
    announcement: announcement(),
    autoPopup: autoPopup()
  })
}

export default defineNuxtPlugin(engagementPlugin)
